import { render, staticRenderFns } from "./CompanyWizard.vue?vue&type=template&id=66c2be14"
import script from "./CompanyWizard.vue?vue&type=script&lang=js"
export * from "./CompanyWizard.vue?vue&type=script&lang=js"
import style0 from "./CompanyWizard.vue?vue&type=style&index=0&id=66c2be14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports